import { render, staticRenderFns } from "./D2MSTD0320.vue?vue&type=template&id=4f9d017a&scoped=true&"
import script from "./D2MSTD0320.js?vue&type=script&lang=js&"
export * from "./D2MSTD0320.js?vue&type=script&lang=js&"
import style0 from "./D2MSTD0320.vue?vue&type=style&index=0&id=4f9d017a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d017a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow,VSpacer})
